const convertToCSV = (data) => {
    const headers = Object.keys(data[0]);
    const rows = data.map(row => headers.map(field => JSON.stringify(row[field], replacer)).join(','));
    const csv = [headers.join(','), ...rows].join('\r\n');
    return csv;
};

const replacer = (key, value) => value === null ? '' : value;

function stripHtml(html) {
  return html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
}

function formatPrice(value) {
  const number = parseFloat(value);
  return `${number.toFixed(2)} INR`; // Format as "5533.00 INR"
}

function Product(data) {
    return data.map(product => {
        return {
            'Name': product?.name || '',
            'AmazonLink': product?.AmazonLink || '',
            'Category': product?.category || '',
            'CouponCode': product?.couponCode || '',
            'Description': product?.description || '',
            'Tax': product?.productTax || '',
            'Short Description': product?.short_description || '',
            'SKU': product?.sku || '',
            'Stock': product?.stock || '',
            'Image Links': (product?.links || []).map(item => item?.url || "").join(', '),
            'ProductBySize': JSON.stringify(product?.priceBySize || [])
        }
    })
}

function Meta(data) {
    return data.map(product => {
        return {
            'id': product._id || '',
            'title': product?.name || '',
            'description': stripHtml(product?.description || ''),
            'availability': product?.stock || '',
            'image_link': product?.links?.[0]?.url || '',
            'price': formatPrice(product.price || 0),
            'link': `https://kansapital.com/product/${product._id}`
        }
    })
}

function Order(data) {
    return data.map(order => {
        const item = order.items[0];
        return {
            'Customer Name': order.customer.name,
            'Customer Number': order.customer.phone,
            'Customer State': order.customer.address.state,
            'Address': `${order.customer.address.Location}, ${order.customer.address.city}, ${order.customer.address.zipCode}`,
            'Product': item.name,
            'Price': item.price,
            'SKU': item.sku,
            'Order ID': order.order_id,
            'Payment ID': order.razorpay.razorpay_payment_id,
            'Status': order.status
        };
    });
}

export const downloadCSV = (data, filename = 'products.csv', key) => {
    const formatted_data = key === 'orders' ? Order(data) : key === 'meta' ? Meta(data) : Product(data)
    const csv = convertToCSV(formatted_data);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
